/* eslint-disable */
import axios from 'axios';
import Moment from 'moment';
import { unregister } from '../registerServiceWorker';
import Helper from './helper';
import { azureAdInstance } from '../index';
import { loginRequest } from '../config/authConfig';
// import RouteConstants from '../constants/routeConstants';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const Axios = axios.create({
    withCredentials: true,
    baseURL: `${new URL(process.env.PUBLIC_URL, window.location.origin)}`,
});

//let notificationTimer: unknown = null;
/**
 * Here Modify request data if needed like Login token, company ids
 */
Axios.interceptors.request.use(async (request) => {
    if (Helper.getStorage('accessToken'))
        request.headers['Authorization'] = `Bearer ${Helper.getStorage('accessToken')}`;

    return request;
}, { synchronous: true });

const redirectLogin = (statusCode) => {
    //... Unregister the service worker.
    if (statusCode === 401 || statusCode === 403) {
        unregister();

        const date = new Date();
        const ts = date.getTime();

        //... Append a time stamp so that the browsers don't cache the url.
        const publicUrl = new URL(
            process.env.PUBLIC_URL,
            window.location.origin
        );
        const url = `${publicUrl}?ts=${ts}`;

        //... Wait for sometime to get the service worker unregistered before redirecting to the root url.
        setTimeout(() => {
            sessionStorage.clear();
            //... Redirect to home so that user gets the ADFS sign-in page.
            window.location.href = url;
        }, 3000);
    }
    return;
};

let isRefreshing = false;
/**
 * Intercept Responses and check if response status os OK.
 */
Axios.interceptors.response.use(
    (response) => {
        /**
         * Added temperory solution to check expired data.
         */
        redirectLogin(response.status);
        return response;
    },
    async (error) => {
        //console.log('error', error);
        //clearTimeout(notificationTimer);
        if (error.response && error.response.status === 401) {
            //&& !isRefreshing
            if (Helper.getStorage('chk') === 'aad') {
                //added isRefreshing to handle multiple request
                //isRefreshing = true;
                const date = new Date();
                const ts = date.getTime();

                //... Append a time stamp so that the browsers don't cache the url.
                const publicUrl = new URL(
                    process.env.PUBLIC_URL,
                    window.location.origin
                );
                const url = `${publicUrl}?ts=${ts}`;
                Helper.reloadPage();
                //code to fetch refreshToken    
                try {
                    const newAccessToken = await refreshAccessToken();
                    Helper.setStorage('accessToken', newAccessToken);
                    isRefreshing = false;
                    window.location.href = url;
                    //Helper.reloadPage();
                    // // Update the request headers with the new access token
                    //error.config.headers['Authorization'] = `Bearer ${newAccessToken}`;
                    // // Retry the original request
                    //return Axios(error.config);
                } catch (refreshError) {
                    isRefreshing = false;
                    console.log('refresh token error', refreshError);
                    // Handle token refresh error
                    throw refreshError;
                }
            }
        }
        else {
            return Promise.reject(error);
        }
    }
    , { synchronous: true });


export const refreshAccessToken = async () => {
    const instance = azureAdInstance.msalInstance;
    const accounts = instance ? instance.getAllAccounts() : null;

    if (instance && accounts && accounts.length > 0 && accounts[0]) {
        const accessTokenRequest = {
            ...loginRequest,
            account: accounts[0],
        }

        try {
            const token = await instance.acquireTokenSilent(accessTokenRequest);
            return token.accessToken;
        } catch (error) {
            if (error instanceof InteractionRequiredAuthError) {
                instance.acquireTokenRedirect(accessTokenRequest);
            } else {
                console.error(error);
            }
        }
    }
    else {
        instance.loginRedirect(loginRequest).catch((error) => console.log(error));
    }

};
export default Axios;
